module.exports = __webpack_public_path__ + "static/audi_a1.582bc394.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/audi_a1.jpg
// module id = 573
// module chunks = 35783957827783